import { useAuth } from '@/store/auth';
import { useAdminContextStore } from '@/store/adminContext';

/**
 * Returns the "active" facilityId based on the current user role.
 * - Facility users: always their own facilityId (from JWT, immutable)
 * - Admin users: the globally selected facilityId from AdminFacilitySelector
 *
 * Use this in any page that needs to scope data to the current facility context.
 */
export function useActiveFacilityId(): string | undefined {
  const { user } = useAuth();
  const selectedFacilityId = useAdminContextStore((s) => s.selectedFacilityId);

  if (!user) return undefined;
  if (user.role === 'facility') return user.facilityId;
  return selectedFacilityId || undefined;
}
